export const attachmentsErrors = {
  NO_ATTACHMENTS: 'No attachments selected',
  NOT_UPLOADED: 'Following files were not uploaded:\n',
};
